import axios from "axios";
import {
  getDataFromLocalStorage,
  removeDataFromLocalStorage,
  storeDataInLocalStorage,
} from "./localStorage";
const baseURL = process.env.REACT_APP_API_URL;
const tokenUrl = `${baseURL}/v1/clinic/access-token`;
export const nonAuthenticatedAxios = axios.create({ baseURL });
export const authenticatedAxios = axios.create({ baseURL });

//TODO: Integrate with login api

//* Add a request inspector
authenticatedAxios.interceptors.request.use(
  (config) => {
    const { accessToken, refreshToken } = getDataFromLocalStorage("user");

    if (accessToken && refreshToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
      config.headers["refreshToken"] = refreshToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//* Add a response inspector
authenticatedAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    const tokens = getDataFromLocalStorage("user");
    const { accessToken, refreshToken } = tokens || {};

    if (error?.response?.status === 401 && originalRequest.url === tokenUrl) {
      removeDataFromLocalStorage("user");
      window.location.href = "/";
      return Promise.reject(error);
    }

    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return authenticatedAxios
        .put(tokenUrl, {
          refreshToken,
        })
        .then((res) => {
          const { accessToken, refreshToken, userData } = res.data.data;
          storeDataInLocalStorage("user", {
            accessToken,
            refreshToken,
            data: {
              ...userData,
            },
          });

          originalRequest.headers = { ...originalRequest.headers };
          originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;

          return authenticatedAxios(originalRequest);
        });
    }
    return Promise.reject(error);
  }
);
